import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const openAutoUploadOnboadingFinalDialog = () => openPopupHelper({ popupName: popupNames.AUTOUPLOAD_ONBOADING_FINAL });
